import atob from "atob";

export const fetchCoordinatesFromGeoCode = async (data) => {
  let Markers = [];

  for (let i = 0; i < data?.length; i++) {
    // Extract data from each item
    const customerData = data[i]?.customer || data[i]?.customerData;
    const geoCode = customerData?.geo_code;
    const id = data[i]?.id;
    const status = data[i]?.status;
    const orderDeliveryStatus = data[i]?.order_delivery?.delivery_status;
    const wantTreatRes = data[i]?.want_treat_response;
    const paymentStatus = data[i]?.order?.payment_status;
    const technicianData = data[i]?.technician;

    // Skip if no geo_code is available
    if (!geoCode) {
      console.log(`Skipping item ${id}: No geo_code available`);
      continue;
    }

    try {
      // Check if geo_code is already a JSON object (happens in some cases)
      if (typeof geoCode === "object" && geoCode !== null) {
        const { lat, lng } = geoCode;
        if (lat && lng && typeof lat === "number" && typeof lng === "number") {
          Markers.push({
            lat,
            lng,
            id,
            status,
            orderDeliveryStatus,
            wantTreatRes,
            paymentStatus,
            technicianData,
            customerData,
          });
          continue;
        }
      }

      // Try to decode as base64
      let decodedGeoCode;
      try {
        // Replace URL unsafe characters before decoding
        const safeGeoCode = geoCode.replace(/-/g, "+").replace(/_/g, "/");
        decodedGeoCode = atob(safeGeoCode);
      } catch (error) {
        console.warn(
          `Base64 decoding failed for item ${id}. Trying to parse directly.`
        );
        // If atob fails, try to see if it's already a JSON string
        decodedGeoCode = geoCode;
      }

      // Try to parse as JSON
      let geoData;

      // Check if it's a valid JSON string
      if (typeof decodedGeoCode === "string") {
        try {
          geoData = JSON.parse(decodedGeoCode);
        } catch (error) {
          console.warn(`JSON parsing failed for item ${id}.`);
          continue;
        }
      } else {
        geoData = decodedGeoCode;
      }

      // Different geo_code formats handling
      let lat, lng;

      // Format 1: { o: { lat, lng } }
      if (geoData.o && geoData.o.lat && geoData.o.lng) {
        lat = geoData.o.lat;
        lng = geoData.o.lng;
      }
      // Format 2: { lat, lng }
      else if (geoData.lat && geoData.lng) {
        lat = geoData.lat;
        lng = geoData.lng;
      }
      // Format 3: Nested inside coords or coordinates
      else if (geoData.coords || geoData.coordinates) {
        const coords = geoData.coords || geoData.coordinates;
        lat = coords.lat || coords.latitude;
        lng = coords.lng || coords.longitude;
      }
      // No valid format found
      else {
        console.warn(`No valid coordinate format found for item ${id}`);
        continue;
      }

      // Validate coordinates
      if (
        typeof lat === "number" &&
        typeof lng === "number" &&
        isFinite(lat) &&
        isFinite(lng)
      ) {
        if (
          wantTreatRes === "true" ||
          wantTreatRes === "no-answer" ||
          wantTreatRes === undefined
        ) {
          Markers.push({
            lat,
            lng,
            id,
            status,
            orderDeliveryStatus,
            wantTreatRes,
            paymentStatus,
            technicianData,
            customerData,
          });
        }
      } else {
        console.warn(
          `Invalid coordinates for item ${id}: lat=${lat}, lng=${lng}`
        );
      }
    } catch (error) {
      console.error(`Error processing geo_code for item ${id}:`, error);
    }
  }

  console.log(
    `Successfully processed ${Markers.length} markers out of ${
      data?.length || 0
    } items`
  );
  return Markers;
};
